import { Router } from "@frui.ts/screens/dist";
import TradingPlacesViewModel from "./tradingPlacesViewModel";
import LocalizationService from "../../services/localizationService";
import TradingPlaceService from "../../services/tradingPlaceService";

export const RoadMapNavigationName = "road_map";

@Router.registerRoute({ route: RoadMapNavigationName, name: "road_map" })
export default class RoadMapViewModel extends TradingPlacesViewModel {
  constructor(public localizationService: LocalizationService, tradingPlacesService: TradingPlaceService) {
    super(localizationService, tradingPlacesService);
    this.navigationName = RoadMapNavigationName;
    this.mapButtonTitle = this.translateGeneral("showTollRoadMap");

    this.showMap = false;
    this.visibleRoads = {
      free: true,
      paid: true,
      year: this.roadMapYears[0],
    };
    this.visibleTradingPlaces = {
      kiosk: false,
      salesPoint: false,
    };
    this.mapButtonClassName = "btn-lg display-map-button";
    this.mapButtonContainerClassName = "text-sm-left";
  }
  protected async onInitialize() {
    await this.tradingPlacesService.initialize();
    return super.onInitialize();
  }
}
